import HistoryRow from 'Components/HistoryRow';
import { editHistoryMenuItems } from 'Components/HistoryRowControls/EditHistory/EditHistoryDialog';
import HistoryRowVerticalItem from 'Components/HistoryRowVerticalItem';
import { calculateDaysDifference, isNumber, isPartialDate } from 'neuro-utils';
import * as React from 'react';
import { formatPartialDate } from 'Utility/date';
import { sortDocumentsDescending } from 'Utility/documentHandling';
import { newButton } from '../../../../utils/functions';

import type { IHistoryContext } from 'Containers/FormContextHandler';

const DEFAULT_DOCUMENTS: IDocumentWithTypeV2<'respiratoryFirstVisit'>[] = [];
const FirstVisitRespiratoryFailureHistory = ({
  documents = DEFAULT_DOCUMENTS,
  startEdit,
  fm,
}: IHistoryContext<IDocumentWithTypeV2<'respiratoryFirstVisit'>>): React.JSX.Element => {
  const fvrf = documents.toSorted(sortDocumentsDescending).at(0);

  const daysDifference = calculateDaysDifference(fvrf?.dateOfReferral, fvrf?.dateOfFirstVisit);

  return (
    <HistoryRow
      headerText={fm('diagnosis.sleepApnea.respiratoryFirstVisit.title')}
      rowButton={
        startEdit
          ? newButton(
              'respiratoryFirstVisit',
              startEdit(fvrf ?? {}, 'respiratoryFirstVisit'),
              'general.edit',
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              fvrf,
            )
          : undefined
      }
      menuItems={editHistoryMenuItems(fvrf)}
    >
      <React.Fragment>
        <HistoryRowVerticalItem
          header={fm('diagnosis.sleepApnea.respiratoryFirstVisit.referralOrAcute')}
          value={
            fvrf?.referralOrAcute
              ? fm(`diagnosis.sleepApnea.respiratoryFirstVisit.opts.${fvrf.referralOrAcute}`)
              : undefined
          }
        />
        {fvrf?.referralOrAcute === 'referral' && (
          <>
            <HistoryRowVerticalItem
              header={fm('diagnosis.sleepApnea.respiratoryFirstVisit.dateOfReferral')}
              value={isPartialDate(fvrf.dateOfReferral) ? formatPartialDate(fvrf.dateOfReferral) : undefined}
            />
            <HistoryRowVerticalItem
              header={fm('diagnosis.sleepApnea.respiratoryFirstVisit.dateOfFirstVisit')}
              value={isPartialDate(fvrf.dateOfFirstVisit) ? formatPartialDate(fvrf.dateOfFirstVisit) : undefined}
            />
            <HistoryRowVerticalItem
              header={fm('diagnosis.sleepApnea.respiratoryFirstVisit.delayFromArrivalToFirstVisit')}
              value={isNumber(daysDifference) ? `${daysDifference} ${fm('diagnosis.sleepApnea.days')}` : undefined}
            />
          </>
        )}
      </React.Fragment>
    </HistoryRow>
  );
};

export default FirstVisitRespiratoryFailureHistory;
